const ComparisonReviewParser = (reviewsArray = [], listings = []) => {
  const first = reviewsArray.filter(review => review.global_product_id === listings[0].global_product_id)
  const last = reviewsArray.filter(review => review.global_product_id === listings[1].global_product_id)
  return {
    first: first.length > 0 ? first : null,
    last: last.length > 0 ? last : null,
  }
}

export const getReviewProps = (
  {
    title,
    created,
    content,
    pros,
    cons,
    language,
    translation_title: translationTitle,
    translation_comments: translationComments,
    translation_pros: translationPros,
    translation_cons: translationCons,
    vendor_reply_text: vendorReply,
    user_info: {
      is_anonymous: isAnonymous,
      is_verified: isVerifiedReviewer,
      full_name: fullName,
      picture_url: pictureUrl,
      job_title: jobTitle,
      company_industry: companyIndustry,
      company_size: companySize,
      frequency_of_use: frequencyOfUse,
      time_used: timeUsed,
      incentivized: reviewIncentivized,
    },
    rating: { total_rounded: ratingOverall, by_field: ratingByField },
  },
  listing
) => {
  const contentInfo = {
    title,
    created,
    content: content || '',
    pros: pros || '',
    cons: cons || '',
    vendorReply: vendorReply || '',
    language,
    translationTitle,
    translationComments,
    translationPros,
    translationCons,
  }
  const reviewer = {
    isAnonymous,
    isVerifiedReviewer,
    fullName,
    pictureUrl,
    jobTitle,
    companyIndustry,
    companySize,
    frequencyOfUse,
    timeUsed,
    reviewIncentivized,
  }
  const rating = {
    overall: ratingOverall,
    byField: ratingByField,
  }
  const listingInfo = {
    listingNumReviews: listing?.num_reviews,
  }

  return {
    ...contentInfo,
    reviewer,
    rating,
    ...listingInfo,
  }
}

export default ComparisonReviewParser
